module.exports = "/static/assets/35b29c7b863985e291b49d355cea293e.png";